var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoredatadash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33648 29.4545C14.3204 25.3859 19.9147 29.255 24.3458 24.4091C27.9885 20.4252 29.7822 12.9545 29.7822 12.5455C29.7822 12.1364 29.7822 11.8636 29.4276 11.8636C29.0731 11.8636 21.6275 11.7273 20.9184 11.7273C20.2093 11.7273 20.2093 11.0455 21.0366 10.6364C21.8639 10.2273 36.2823 0 36.2823 0C36.2823 0 46.0915 9.27273 47.3915 10.9091C48.6915 12.5455 47.6279 12.5455 46.8006 12.5455C45.9733 12.5455 39.9459 12.5455 38.6459 12.5455C37.3459 12.5455 36.9914 13.7727 36.9914 13.7727C36.9914 13.7727 35.2872 24.9851 30.6095 29.4545C26.3565 33.5182 21.5462 30.3076 17.0184 33.9545C13.088 37.1203 9.33648 45 9.33648 45H0C0 45 4.11078 33.7205 9.33648 29.4545Z",
    fill: "#F3123C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.9722,
    y: 37.3636,
    width: 1.4182,
    height: 7.63636,
    fill: "#F3123C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.63633,
    height: 6.61842,
    transform: "matrix(0.0105627 0.999944 -0.999901 0.0140618 47.9824 40.3172)",
    fill: "#F3123C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoredatadash);
export default __webpack_public_path__ + "static/media/moredatadash.3a559cfd87b09c04078e9878a52f97aa.svg";
export { ForwardRef as ReactComponent };